import { Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
// import CreateEditBusinessUnitModal from "./createEditBusinessUnit";
import {
  actionsColumn,
  hideColumn,
  textColumn
} from "../../components/tableComponent/columns";
import TableComponent from "../../components/tableComponent";
// import "./styles.css";
import {
  callApiAsync,
  GetEnterpriseActive,
  InactiveEnterprise
} from "../../services/apiService";
import ToastNotification from "../../components/toastNotification";
import ButtonComponent from "../../components/button";
import icons from "../../constants/icons";
import ConfirmationModal from "../DBAdmin/ConfirmationModal";
const DBAdmin = () => {
  const [dbNames, setDBNames] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [selectedRow, setSelectedRow] = useState({});

  const [alertOpen, setAlertOpen] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("warning");

  const getDbTable = () => {
    callApiAsync(GetEnterpriseActive, (data) => {
      setDBNames(data);
    });
  };

  const deleteDb = () => {
    console.log('selectedRow',selectedRow);
    callApiAsync(
      () => InactiveEnterprise(selectedRow),
      (data) => {
        if(data){
          setToastMessage(data);
          setToastOpen(true);
        }
      getDbTable();
      }
    );
  };

  useEffect(() => {
    getDbTable();
  }, []);

  const handleConfirmation = (row) => {
    if (!row) {
      setSelectedRow({});
      return;
    }
    setSelectedRow(row);
    setOpenConfirmation(true);
  };

  const handleClose = () => {
    setOpenConfirmation(false);
  };

  const actionBtn = ({ row }) => (
    <div className="HContainer">
      <ButtonComponent
        onClick={() => handleConfirmation(row.original)}
        variant="contained"
        backgroundColor="#fff0"
      >
        <img className="btn-icon" src={icons.red_delete} alt="icon" />
      </ButtonComponent>
    </div>
  );

  const columns = useMemo(
    () => [
      textColumn("name", "Nombre"),
      textColumn("shardKey", "shardKey"),
      actionsColumn(actionBtn)
    ]
  );

  return (
    <div>
      <h1>Gestion de base de datos</h1>
      <div>
        <TableComponent
          columns={columns}
          data={dbNames}
          enableGlobalFilter={true}
          initialState={{
            sorting: [
              {
                id: "name",
                desc: false
              }
            ]
          }}
        />
      </div>
      <ConfirmationModal 
        open={openConfirmation} 
        onClose={handleClose} 
        rowData={selectedRow}
        onSubmitFunction={deleteDb}/>
      <ToastNotification
        open={toastOpen}
        handleClose={() => setToastOpen(false)}
        message={toastMessage}
        severity={toastSeverity}
      />
    </div>
  );
};

export default DBAdmin;
